<template>
  <div class="new-content">
    <ul class="list" v-if="!_.isEmpty(dataSet.result)">
      <li v-for="(item, index) in dataSet.result" :key="`faq-list-${index}`">
        <div class="content">
          <p class="title">{{$t('faq.q')}}{{item.question}}</p>
          <div class="desc" v-html="$h.removeXSS($options.filters.addPreTag(item.answer, $t('faq.a')))"></div>
        </div>
      </li>
    </ul>
    <div class="nodata" v-else-if="!isShowLoader && _.isEmpty(dataSet.result)">{{$t('common.noResult')}}</div>
    <Page :total="dataSet.count" :page-size="pageSize" :current.sync="currentPage" size="small" @on-change="goPager" v-if="dataSet.count > pageSize"></Page>
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
  </div>
</template>

<script>
import Vue from 'vue'
import Loader from '../layout/Loader'

export default {
  name: 'FaqListContent',
  components: { Loader },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    pageSize: {
      type: Number
    },
    isShowLoader: {
      type: Boolean
    }
  },
  data () {
    return {
      currentPage: 1
    }
  },
  filters: {
    addPreTag (str, preStr) {
      let plainText = Vue.filter('removeTag')(str)
      if (Vue._.isEmpty(plainText)) return preStr
      str = Vue._.replace(str, new RegExp(Vue._.escapeRegExp(plainText.substr(0, 5)), 'i'), `${preStr}$&`)
      return str
    }
  },
  methods: {
    goPager (page) {
      this.$parent.getData(page)
    }
  }
}
</script>
<style scoped>
  .new-content{
    margin-top: 30px;
  }
  .new-content >>> .ivu-page{
    text-align: center;
    margin: 50px 0 15px;
  }
  .new-content >>> .ivu-page-item-active{
    background-color: #1F8AFD;
    border-color: #1F8AFD;
  }
  .list li{
    position: relative;
    padding-right: 5px;
    margin-bottom: 25px;
  }
  .list li:last-child{
    margin-bottom: 0;
  }
  .list li .title{
    margin-bottom: 5px;
    padding-bottom: 2px;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #333;
  }
  .list li .title,
  .list li .desc{
    line-height: 22px;
  }
  .list li .desc{
    font-size: 14px;
    color: #333;
  }
  .nodata{
    text-align: center;
    padding-top: 30px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/faq/ListContent.vue